// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3AHfX","rootSmall":"AddTileButton_rootSmall__HrCv7"};